import { Pipe, PipeTransform } from "@angular/core";

export enum ProjectRegion {
  NORTH_EAST = "NORTH_EAST",
  SOUTH = "SOUTH",
  WEST = "WEST",
}

@Pipe({
  name: "translateProjectRegion",
  standalone: true,
})
export class TranslateProjectRegionPipe implements PipeTransform {
  private readonly translations: Record<string, string> = {
    [ProjectRegion.NORTH_EAST]: $localize`:@@projectRegion.north_east:NordOst`,
    [ProjectRegion.SOUTH]: $localize`:@@projectRegion.south:Süd`,
    [ProjectRegion.WEST]: $localize`:@@projectRegion.west:West`,
  };

  transform(region: ProjectRegion): string {
    return this.translations[region] ?? $localize`:@@projectRegion.unknown:Unknown region`;
  }
}
